import React from 'react';

import { formatDate as formatBreakfastHours } from 'components/daypart-menu-header/utils';
import { useRoute } from 'hooks/navigation/use-route';
import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';
import { useDayPartSelector } from 'state/menu/main-menu/hooks/use-day-part-selector';
import { isSectionRoute } from 'utils/routing';

import { Container, DaypartHoursText, SunriseIcon } from './styled';

export const MenuTileGridHeader: React.FC = () => {
  const { pathname } = useRoute();
  const { region, language } = useLocale();

  const { breakfastInterval } = useDayPartSelector();

  const isMenuSectionRoute = isSectionRoute(pathname);

  if (isMenuSectionRoute || !breakfastInterval) {
    return null;
  }

  const endDateHours = formatBreakfastHours({ date: breakfastInterval.endTime, region, language });
  const dayPartHoursMessage = t('breakfastDayPartHours', { endDateHours });

  return endDateHours ? (
    <Container>
      <SunriseIcon />
      <DaypartHoursText>{dayPartHoursMessage}</DaypartHoursText>
    </Container>
  ) : null;
};
